export enum OnlineApplicationPrintRoutesEnum {
  AGRO = 'agro',
  BUSINESS = 'business',
  CONSUMER = 'consumer',
  STUDENT = 'student',
  CREDIT_LINE = 'credit-line',
  MORTGAGE = 'mortgage',
  GUARANTEE = 'guarantee',
  FACTORING = 'factoring',
  ACREDETIVE = 'acredetive',
  INCASSO = 'incasso',
  CARD = 'card',
  CREDIT_CARD = 'credit-card',
  DEBIT_CARD = 'debit-card',
}
